export default __webpack_public_path__ + "static/media/pizzeria_camion_pizza.7b2757de.png";